<template>
  <div class="post-content">
    <div class="post-content-share">
      <b>Compartilhe</b>
      <ul>
        <li>
          <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u='+ shareUrl">
            <svg class="post-content-share-icon"><use xlink:href="#icon-share--facebook" /></svg>
          </a>
        </li>
        <li>
          <a target="_blank" :href="'http://twitter.com/share?url='+ shareUrl">
            <svg class="post-content-share-icon"><use xlink:href="#icon-share--twitter" /></svg>
          </a>
        </li>
        <li>
          <a target="_blank" :href="'https://wa.me/?text='+ shareUrl">
            <svg class="post-content-share-icon"><use xlink:href="#icon-share--whatsapp" /></svg>
          </a>
        </li>
      </ul>
    </div>

    <div class="post-content-data">
      <components class="post-content-data__content" :is="'post-'+ block.type" :data="block.data" v-for="(block, index) in content" :key="index" />
    </div>
  </div>
</template>

<script>
import Chart from '@/components/Post/Chart.vue';
import PostText from '@/components/Post/Text.vue';
import PostQuote from '@/components/Post/Quote.vue';
import Video from '@/components/Post/Video.vue';

export default {
  computed: {
    shareUrl() {
      return window.location.href;
    },
  },
  props: [
    'content',
  ],
  components: {
    'post-chart': Chart,
    'post-text': PostText,
    'post-quote': PostQuote,
    'post-video': Video,
  },
};
</script>

<style lang="scss">
.post-content {
  position: relative;

  width: 100%;
}

.post-content-share {
  position: relative;

  width: 100%;
  max-width: rem-calc(980);

  display: grid;
  grid-gap: rem-calc(0 20);
  grid-template-columns: 1fr;

  margin-bottom: rem-calc(20);

  @media #{$medium-up} {
    grid-template-columns: 1fr minmax(auto, rem-calc(680));
  }

  b {
    display: block;

    color: $boulder;
    text-align: left;
    font-size: rem-calc(16);
    font-weight: normal;
    line-height: rem-calc(25);

    @media #{$medium-up} {
      text-align: right;
    }
  }

  ul {
    display: flex;
  }

  li {
    max-width: rem-calc(25);
    max-height: rem-calc(25);

    margin-right: rem-calc(15);
  }

  a {
    display: block;

    width: rem-calc(25);
    height: rem-calc(25);
  }

  svg {
    width: 100%;
    height: 100%;
  }
}

.post-content-data {
  position: relative;

  width: 100%;
  max-width: rem-calc(980);

  display: grid;
  grid-template-columns: 1fr minmax(auto, rem-calc(685));
}

.post-content-data__content {
  margin-bottom: rem-calc(40);
}

.button-methodology {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 260px;
  height: 50px;
  margin: 0 auto;
  
  background-color: $minsk;
  border-radius: 30px;
  
  color: $white;
  font-size: 14px;
  font-weight: bold;

  cursor: pointer;
  outline: 0;
}

.button-methodology-icon {
  width: 29px;
  height: 31px;
  margin-left: 15px;
}
</style>
